import classNames from "classnames";
import type { ReactNode } from "react";
import { BaseButton } from "../../components/Button/BaseButton.tsx";
import { GeneratedContentContainer } from "../Board/components/GeneratedContent/GeneratedContentContainer.tsx";
import type { Content } from "../Board/types.ts";

// FIXME: We should create common tile action button component that will be used in all the tiles to standardize the action button behavior and style
export const ActionContentTile = ({
  content,
  id,
  topLeftElement,
  topRightElement,
  bottomRightElement,
  onClick,
  className,
  contentClassName,
}: {
  content: Content;
  id?: string;
  topLeftElement?: ReactNode;
  topRightElement?: ReactNode;
  bottomRightElement?: ReactNode;
  onClick?: () => void;
  className?: string;
  contentClassName?: string;
}) => (
  <div
    className={classNames("w-full group relative overflow-clip", className)}
    id={id}
  >
    <div className="z-10 absolute top-200 left-200">{topLeftElement}</div>
    <div className="z-10 absolute top-200 right-200">{topRightElement}</div>
    <div className="z-10 absolute bottom-200 right-200">
      {bottomRightElement}
    </div>
    <BaseButton className="w-full block" onClick={onClick}>
      {/* FIXME: add breakpoints to ask for smaller srcDimension if the screen is small */}
      {/* FIXME: in order to have good quality images without watermark we rely here on the fact that
           we fetch from the CDN without watermark, even if the size is above the limit in CF */}
      <GeneratedContentContainer
        content={content}
        contentClassName={contentClassName}
        allowGrow
      />
      {content.status === "SUCCEEDED" && (
        <div className="absolute left-0 bottom-0 w-full h-full invisible group-hover:visible bg-gradient-to-t from-[#1D1E21]/80 to-65%" />
      )}
    </BaseButton>
  </div>
);
